// Imports
import { GetMemberResponse } from '../../../shareables/types/api/main/website/member/get';


/** Function that generates an array of notification items based on the member's available notifications */
const notificationBoxItems = (member: GetMemberResponse) => {
	// Return items
	return [
		...(member?.notifications?.availableSurveys
			? [
					{
						type: 'link',
						to: '/surveys',
						content: `${member.notifications.availableSurveys} survey${member.notifications.availableSurveys === 1 ? '' : 's'} to take`,
						uniqueKey: 'surveys',
					},
				]
			: []),
		...(member?.notifications?.availablePaymentOptions
			? [
					{
						type: 'link',
						to: '/payments',
						content: `${member.notifications.availablePaymentOptions} online payment option${member.notifications.availablePaymentOptions === 1 ? '' : 's'} available`,
						uniqueKey: 'payments',
					},
				]
			: []),
	];
};

export default notificationBoxItems;
